import {SidebarMenuItem} from "./SidebarMenuItem";
import {useServerMenus} from "../Menu/useServerMenus";

export const SidebarItem = () => {

    const {userMenus} = useServerMenus();
    return userMenus.map(x => <SidebarMenuItem key={x.id} menu={x}/>);
}
